import React from "react";
import { Login } from "./Login";
import { LoginDemo } from "../LoginDemo";

export const LoginContainer: React.FC = () => (
  window.origin.includes('app-demo') ? <LoginDemo /> : <Login />
);
